<template>
  <div class="routerInfo">

    <div class="container-fluid container-panel container-mainblock">
      <div class="container">
        <div class="container-head">
          <div class="mainblock-left">
            <font-awesome-icon class="mainblock-icon" style="color: red" icon="newspaper"></font-awesome-icon>
            <a  class="mainblock-label">个人积分</a>
          </div>

        </div>
        <div class="container-body panel-party">
          <div class="party-right">
            <div class="party-block">
              <div class="userPointContainer">
                <div class="userPointLabel">成长总积分</div>
                <div class="userPointValue">{{totalScore}}</div>
              </div>
              <div class="pointTab">
                <div class="pointRuleLabel">积分规则</div>
                <div class="pointGoalLabel">今日已获得{{dayScore}}积分</div>
              </div>
              <div class="pointContainer">
                <div v-for="item in rankList" class="pointItem">
                  <div class="pointInfo">
                    <div class="pointInfoRow">
                      <div class="pointName">{{item.rankConfigName}}</div>
                      <div class="pointRule">+{{item.rankConfigValue}}分/{{item.rankConfigContent}}</div>
                    </div>
                    <div class="progressContainer">
                      <div class="progress" :style="{'width': item.width}"></div>
                    </div>
                    <div class="pointInfoRow">
                      <div class="pointScore">已获{{item.rankScore}}分</div>
                      <div class="pointScore">上限{{item.rankConfigLimit}}分</div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style rel='stylesheet/less' lang='less' scoped>
  @import "../../assets/less/variables.less";
  @import "../../assets/less/mySearch.less";
  @import "../../assets/less/style.less";
  .pointContainer {
    display: flex;
    flex-direction: column;
  }

  .pointItem {
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    padding-top: 10px;
    width: 30vw;
    background-color: white;
    padding-bottom: 10px;
    border-top: 1px solid darkgray;
  }

  .pointInfo {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .pointInfoRow {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .pointName{
    font-size: 14px;
    color: black;
    font-weight: bold;
  }

  .pointRule{
    font-size: 12px;
    color: #FEB26E;
  }
  .progressContainer{
    width: 100%;
    background-color: #C0C0C0;
    height: 4px;
    border-radius: 2px;
    margin-top: 8px;
  }
  .progress{
    height: 100%;
    background-color: #F44336;
    border-radius: 2px;
  }
  .btnContainer{
    width: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pointScore{
    margin-top: 8px;
    color: #bdbdbd;
    font-size: 12px;
  }
  .toLook{
    color: white;
    padding: 8px 12px 8px 12px;
    background-color: #F44336;
    border-radius: 5px;
    font-size: 14px;
  }
  .pointTab{
    height: 35px;
    width: 30vw;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .pointRuleLabel{
    padding-left: 5px;
    border-left: 5px solid #F44336;
    margin-left: 10px;
    font-weight: bold;
    font-size: 16px;
  }

  .pointGoalLabel{
    margin-right: 20px;
    font-size: 12px;
  }
  .userPointContainer{
    width: 30vw;
    height: 10vw;
    background-color: #F44336;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .userPointLabel{
    font-size: 12px;
    color: white;
    margin-top: 3vw;
  }
  .party-block{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .userPointValue{
    font-size: 25px;
    font-weight: bold;
    color: white;
    margin-top: 10px;
  }
</style>

<script type="text/ecmascript-6">
  import viewFunction from "../../assets/js/viewFunction";
  import { mapState, mapGetters } from 'vuex'
  export default {
    name: 'Training',
    inject:['check'],
    data(){
      return {
        newsList: [],
        totalScore: '',
        dayScore: '',
        rankList: [
        ]
      }
    },
    mounted() {
      this.findAllData()
    },
    computed: {
      ...mapState({
        user: state => state.user
      }),
      ...mapGetters({
        navigationList: 'navs'
      })
    },
    methods:{
      findAllData(){
        var params = {
          userId:this.user.userId,
        }
        let url = '/api/userRank/findUserRankInfo'
        let that = this
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function (){
            that.rankList = res.data.rankList
            that.rankList.forEach(item => {
              if(item.rankConfigLimit!=0){
                item.width = (item.rankScore*100/item.rankConfigLimit)+"%"
              }else {
                item.width = '0%'
              }

            })
            that.totalScore= res.data.totalScore
            that.dayScore = res.data.dayScore
        }))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/learn/Point.vue